
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/geography-of-business",
      function () {
        return require("private-next-pages/about-us/geography-of-business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/geography-of-business"])
      });
    }
  